import { Form, Input, Modal, notification } from "antd";
import React, { useState } from "react";
import Utils from "../../utils/Utils";
import { requestAccessPostApi } from "../../api/candidate";
import WebUtils from "../../utils/WebUtils";
import TextArea from "antd/es/input/TextArea";
import { Loader2 } from "lucide-react";

const userDetail = Utils.getUserDetail();

const RequestAccessModal = ({ openModal, closeModal, moduleName }) => {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const onFinish = (value) => {
    const url = `${requestAccessPostApi}?userIdentifier=${
      userDetail?.userIdentifier || null
    }&requestModules=${value.moduleType}&descriptions=${
      value.description || ""
    }`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "POST")
      .then((result) => {
        if (result.data.resultStatusInfo.resultCode === "SUCCESS") {
          form.resetFields();
          closeModal();
          notification.success({
            description: `We have received your request, our team will contact you soon `,
            placement: "topRight",
            showProgress: true,
          });

          setLoading(false);
        } else {
          setLoading(false);
          notification.warning({
            message: "Failed to send request",
            placement: "topRight",
            showProgress: true,
          });
        }
      })
      .catch((err) => {
        setLoading(false);
        notification.warning({
          message: "Failed to send request",
          placement: "topRight",
          showProgress: true,
        });
        console.log(err);
      });
  };
  return (
    <Modal
      open={openModal}
      onCancel={closeModal}
      footer={null}
      centered
      width={600}
    >
      <div className="">
        <p className="font-semibold text-center text-xl">Contact us</p>
        <div className="px-3 mt-2">
          <Form
            form={form}
            name="contact-form"
            layout="vertical"
            onFinish={onFinish}
            className="w-full"
            initialValues={{
              moduleType: moduleName,
            }}
          >
            <Form.Item
              name="moduleType"
              label={<span className="text-design">Module Type</span>}
              rules={[
                {
                  required: true,
                  message: "Please enter the module type!",
                },
              ]}
            >
              <Input placeholder="Module type" disabled={moduleName} />
            </Form.Item>
            <Form.Item
              name="description"
              label={<span className="text-design">Description</span>}
              rules={[
                {
                  max: 300,
                  required: true,
                  message: "Please provide description!",
                },
              ]}
            >
              <TextArea
                placeholder="Enter description"
                rows={4}
                maxLength={300}
                showCount
                autoSize={{
                  minRows: 5,
                  maxRows: 8,
                }}
              />
            </Form.Item>
            <Form.Item className="p-0 m-0">
              <p className="text-center p-0 m-0">
                <button
                  disabled={loading}
                  type="primary"
                  htmlType="submit"
                  size="large"
                  className="text-[1rem] w-60 m-auto btn-orange py-[7px] px-3 "
                >
                  {loading ? (
                    <span className="flex justify-center gap-2 items-center">
                      Requesting...{" "}
                      <Loader2 size={20} className="animate-spin" />
                    </span>
                  ) : (
                    "Request Access"
                  )}
                </button>
              </p>
            </Form.Item>
          </Form>
        </div>
      </div>
    </Modal>
  );
};

export default RequestAccessModal;
